<template>
  <count-to ref="mianCount" :start-val="0" :end-val="endValue" :duration="duration" :autoplay="true" />
</template>
<script>
  import CountTo from "vue-count-to";
  export default {
    components: {
      CountTo,
    },
    props: {
      endValue: {
        type: Number,
        default: 0
      },
      duration: {
        type: Number,
        default: 7000
      },
      playTimer: {
        type: Number,
        default: 30000
      },
      isOpenPlayTimer:{
        type:String,
        default:'1'
      }
    },
    computed: {

    },
    data() {
      return {
        timer: null
      }
    },
    watch: {
      playTimer() {
        this.closeTimer()
        this.createTimer()
      },
      isOpenPlayTimer(){
        if(this.isOpenPlayTimer=='1'){
          this.createTimer()
        }else{
          this.closeTimer()
        }
      }

    },
    mounted() {
      this.createTimer()
    },
    beforeDestroy() {
      this.closeTimer()
    },
    methods: {
      closeTimer() {
        if (this.timers) {
          clearInterval(this.timers)
          this.timers = null
        }
      },
      resetData() {
        let that = this
        if (that.$refs.mianCount) {
          that.$refs.mianCount.start()
        }
      },
      createTimer() {
        let that = this
        if (!this.timers) {
          this.timers = setInterval(function() {
            that.resetData()
          }, this.playTimer ? this.playTimer : 30 * 1000)
        }
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/text/components/numberComponents.vue